import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import type { LoyaltyActionRewardCalculateEarnResult } from 'api/mappers/loyalty/mapLoyaltyActionRewards'
import requestUtils from 'api/requestUtils'

type BatchCalculatePayload =
  paths['/api/lux-loyalty/points/action-rewards/calculate-earn/batch']['post']['requestBody']['content']['application/json']
type BatchCalculateResponse =
  paths['/api/lux-loyalty/points/action-rewards/calculate-earn/batch']['post']['responses']['200']['content']['application/json']

/** Batch calculate earn estimates for action rewards. */
export async function requestLoyaltyActionRewardsEarnCalculationBatch(
  customerId: string,
  actions: NonNullable<BatchCalculatePayload['actions']>,
): Promise<Array<LoyaltyActionRewardCalculateEarnResult>> {
  const payload: BatchCalculatePayload = {
    customerId,
    actions,
  }

  const response = await requestUtils.post<BatchCalculateResponse, BatchCalculatePayload>(
    '/api/lux-loyalty/points/action-rewards/calculate-earn/batch',
    payload,
    { credentials: 'include' },
  )

  return response.results
}
